__turbopack_context__.v({
  "container": "RelatedArticles-module-scss-module__9zy3Zq__container",
  "imageWrapper": "RelatedArticles-module-scss-module__9zy3Zq__imageWrapper",
  "storySubtitle": "RelatedArticles-module-scss-module__9zy3Zq__storySubtitle",
});
